import {Card, FormControl, FormField, Separator} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {ArticleUpdateJobSource} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';
import {BranchScope} from './BranchScope';
import {DefaultSupplierScope} from './DefaultSupplierScope';
import {WarehouseScope} from './WarehouseScope';

interface ArticlesScopeFormProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
  source: ArticleUpdateJobSource | Nullish;
}

export function ArticlesScopeForm(props: ArticlesScopeFormProps) {
  return (
    <Card
      hasSeparator
      title={i18n.t('entity.warehouse.labels.articlesScope')}
      variant="inlineGrey"
      tooltip={i18n.t('entity.warehouse.labels.articlesScopeTooltip')}
    >
      <VStack spacing={4}>
        <Grid columns={3} spacing={4}>
          <GridItem span={1}>
            <FormField
              isDisabled={props.source === 'INTEGRATION'}
              control={props.control}
              type="switch"
              name="articlesScope.articleScopeLimitToUpdateList"
              label={i18n.t('entity.warehouse.labels.limitToUpdateList')}
              data-testid={suffixTestId('inputs.limitToUpdateList', props)}
            />
          </GridItem>
        </Grid>
        <Separator spacing={0} />
        <Grid columns={3} spacing={4}>
          <GridItem span={1}>
            <BranchScope
              control={props.control}
              formApi={props.formApi}
              data-testid={suffixTestId('branchScope', props)}
            />
          </GridItem>
          <GridItem span={1}>
            <WarehouseScope
              control={props.control}
              formApi={props.formApi}
              data-testid={suffixTestId('warehouseScope', props)}
            />
          </GridItem>
          <GridItem span={1}>
            <DefaultSupplierScope
              control={props.control}
              formApi={props.formApi}
              data-testid={suffixTestId('defaultSupplierScope', props)}
            />
          </GridItem>
        </Grid>
      </VStack>
    </Card>
  );
}
